import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Reflecting on 2020",
  "description": "The year that felt like a drag and ended in the blink of an eye. ",
  "published": "2021-01-02T00:00:00.000Z",
  "categories": "Personal, Learning",
  "hero": "./img/screenshot-1609606475407.png"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "540px",
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/c1ff5a11f1a79abc6421b3f7ad4ae3d8/07484/etwDdPpng5hj12e.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "101.79372197309418%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'407\\'%20viewBox=\\'0%200%20400%20407\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M2%20102l1%2099h395V4H2v98m90-65c-9%204-15%2013-17%2028-1%2010-1%2010%206%2010h6v-8c1-13%207-20%2015-20%2010%200%2015%207%2015%2020%200%2015-1%2018-34%2086l-10%2022h55v-12h-19l-18-1%208-15c14-27%2024-48%2026-56%209-25%205-45-9-52-6-3-19-4-24-2m144%200c-10%204-15%2013-17%2028-1%2010-1%2010%206%2010h6v-9c1-13%206-18%2016-18%206%200%206%200%209%203%205%205%207%2012%205%2024-3%2013-5%2019-38%2085l-6%2014%2028%201h28v-12h-19c-18%200-20%200-18-3%201-1%2027-52%2030-61%2010-24%2010-45%200-55-6-7-21-10-30-7m63%203c-4%203-6%208-6%2014l-1%206c-3%200-3%204-3%2052-1%2040-1%2048%201%2050%200%202%201%203%202%203l-1-3c-3-5-1-7%205-7l5-1v-11c-1-15-2-18-4-17-1%200-2%200-1-3l-1-3c-1-1-1%200-1%201l-1%202-1-5%201-4%201-2h-1l-1-10c-1-11-1-13%202-10%201%202%201%201%201-6s0-9%202-9l1%202a939%20939%200%20002%206c1%200%202-5%201-12l2-8%201-3v8l1-3c2-4%203-3%203%205v8l-1%205-1%203c-3%200-2%2044%202%2058v4c0%203%201%203%2014%204%2011%200%2011%200%2012-2s1-2%201%203c2%209-3%2016-10%2019-6%202-6%202-3%202%208%200%2015-8%2015-18%200-4%201-4%202-4%202%200%202-3%202-46%200-46%200-47-2-47s-2-1-2-6v-5l-1%205c-2%209-2%209%201%209%202%200%203%202%203%2025l-1%2013-1-8-1%2022c0%2015%200%2022-1%2021l-1-33c-1-34-2-44-5-44-2%201-3%205-3%2018a290%20290%200%2001-2%2013c0-17-2-20-2-4l-1%2022v2l-1-2c-1-2-1-2-1%200l1%202v2l-1%2015-1%2017c-1%204-2-3-2-24a239%20239%200%2000-1-11c0%2010%200%2011-2%2011-2-1-3-5-1-5l1-1v-2l-1-5-1-20-1-22v-6h-4c-3%200-4%201-5%202h-1c0-2-1-2-3-2-4%200-4%200-3-8s3-11%209-14c2-1%202-1%200-1l-5%203m-144%205v9c0%204%200%204-2%205-3%200-3%204-3%2054%200%2045%200%2049%203%2052%202%202%203%200%201-2s-3-6-2-8l5-1%206-1-1-10a586%20586%200%2001-3-18l-1%201-1-3c0-6-1-12-3-13-1-1-2-19%200-19l1%202c0%202%200%202%201-1v-8l2-8c2-4%202-4%202%202v6c2%202%202%202%202-2l1-9v-8a321%20321%200%20002-1c0%203%200%203%201%202%201-2%202-2%202-1%202%202%202%2026%201%2026l-1-1h-1a177%20177%200%20003%2058l1%204h12c7%200%2013%201%2013%202%202%202%201%207-2%2012-2%205-3%205-8%207l-5%202h4c7-1%2013-7%2014-18l2-4a482%20482%200%2000-3-100c0-7-1-6-1%203-1%207-1%207%201%207%203-1%203%201%203%2022%200%2013-1%2016-1%2010l-1-8v6a601%20601%200%2000-3%2010%20345%20345%200%2000-2-38c0-3-2-7-4-6-1%202-2%2010-2%2021%200%2016-2%2016-2%200V66l-1%2020a412%20412%200%2001-3%2041c-2%2029-3%2022-3-13%200-33-1-42-1-18-1%2028-1%2027-2%2024l-1-6c0-8%200-10-1-7-1%201-1-7-1-21a1037%201037%200%20000-25c1-1-1-1-5-1h-6l-3-1h-3v-6l1-8%201-3-3%203M2%20302v98h396V203H2v99m307-59l-1%209-1%206c-2%201-2%203-2%2012v11h10c2%201%202%200%202-10l-1-12h-2l-1-8c-1-9-2-12-4-8m-228%202c-11%203-18%2015-19%2031v9h13v-9c1-12%205-18%2013-20%2012-3%2020%206%2019%2022s-4%2022-30%2076l-17%2035%2029%201h29l1-4v-8H80l14-31c23-45%2025-52%2025-71%200-10%200-11-3-18-4-7-8-11-15-13H81m71%202c-4%203-6%207-6%2014%200%205%200%206-2%207-3%200-3%207-3%2060v46l2%204%204%204-2-4c-5-8-4-10%204-11%205%200%206-1%206-2l-1-12c-1-12-2-16-3-15-1%200-2-1-3-6v-4l-2%203c-1%202-1%202-1-3a458%20458%200%20000-27l1%202h1l1-9%201-7%201-2%201%201v4c-1%201%200%204%202%205%201%200%202-3%202-10-1-5%200-9%201-11l1-3v4c0%203%200%203%201%201%201-4%202-2%203%203%202%2013%201%2025-1%2020-2-4-2%201-2%2017a134%20134%200%20004%2046c0%204%201%205%2014%205s13%200%2014%202c1%203%200%206-3%2013l-2%205c3-1%206-9%207-15%200-4%201-5%202-5%202%200%202-3%202-49%200-48%200-49-2-49s-2-1-2-5l-1-7c-1-2-1-1-1%203v9c-1%204-1%204%201%203%203%200%204%204%204%2026%200%2018-1%2019-2%205-1-8-1-5-1%2017l-1%2029c-1%201-1-12-1-31a310%20310%200%2000-3-45l-2-5c-2-1-3%205-4%2024l-1%2020-1-19v-19l-1%2015a471%20471%200%2001-5%2068c-2%206-2-3-2-36v-29l-1%2024-1%2018c-2%200-2-5-2-9%201-4%201-6-1-8v-12l-1-17v-18h4l-4-1c-9%200-10%200-9%201%200%202-2%201-2%200l-4-2h-3v-6c0-8%204-14%209-17%203-1%203-1%201-1l-5%203m79-2c-11%204-18%2018-18%2035v5h13v-9c1-14%205-19%2016-20%2012%200%2017%207%2016%2023-1%2015-3%2020-30%2075l-17%2035h59v-12l-19%201-20-1a600%20600%200%200130-62c16-34%2012-62-8-69-5-2-17-2-22-1m77%2045h-3l-1%2034v35h-4c-5%200-3%202%202%203l5%201v12c0%2012%200%2012-2%2013-4%201-2%202%205%202l7-1-2-1c-2%200-2%200-2-12l2-13%205-1%204-1c0-1-1-2-3-2h-3a582%20582%200%2001-3-34l-2-2h2c2%200%202%200%202-17v-17h-3l-6%201M0%20405v2h401v-5H0v3\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/c1ff5a11f1a79abc6421b3f7ad4ae3d8/ca0a1/etwDdPpng5hj12e.webp 223w", "/static/c1ff5a11f1a79abc6421b3f7ad4ae3d8/75680/etwDdPpng5hj12e.webp 445w", "/static/c1ff5a11f1a79abc6421b3f7ad4ae3d8/9e625/etwDdPpng5hj12e.webp 540w"],
              "sizes": "(max-width: 540px) 100vw, 540px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/c1ff5a11f1a79abc6421b3f7ad4ae3d8/e92b6/etwDdPpng5hj12e.png 223w", "/static/c1ff5a11f1a79abc6421b3f7ad4ae3d8/e66bf/etwDdPpng5hj12e.png 445w", "/static/c1ff5a11f1a79abc6421b3f7ad4ae3d8/07484/etwDdPpng5hj12e.png 540w"],
              "sizes": "(max-width: 540px) 100vw, 540px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/static/c1ff5a11f1a79abc6421b3f7ad4ae3d8/07484/etwDdPpng5hj12e.png",
              "alt": "etwDdPpng5hj12e",
              "title": "etwDdPpng5hj12e",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`2020 feels like a decade of history packed into a couple short months.`}</p>
    <p>{`Yet nothing happened. We waited. Lived in starts and sputters as restrictions came and went.`}</p>
    <p>{`So much Netflix 🤮`}</p>
    <blockquote {...{
      "className": "twitter-tweet",
      "data-dnt": "true"
    }}><p parentName="blockquote" {...{
        "lang": "en",
        "dir": "ltr"
      }}>{`Welcome 2021 can’t wait to travel again `}<a parentName="p" {...{
          "href": "https://t.co/dRp90cruX7"
        }}>{`pic.twitter.com/dRp90cruX7`}</a></p>{`— Swizec Teller published ServerlessHandbook.dev (@Swizec) `}<a parentName="blockquote" {...{
        "href": "https://twitter.com/Swizec/status/1345027516184973312"
      }}>{`January 1, 2021`}</a></blockquote>
    <h2 {...{
      "id": "the-days-are-long-but-the-weeks-are-short"
    }}>{`The days are long but the weeks are short`}</h2>
    <blockquote>
      <p parentName="blockquote">{`Most people overestimate what they can do in one year and underestimate what they can do in ten years.
~ Bill Gates`}</p>
    </blockquote>
    <p>{`Since 2020 felt like the longest decade, we got a decade of work done ... right?`}</p>
    <p>{`Not quite my friend.`}</p>
    <p>{`For me, the year felt like a war of attrition. Little by little, hour by hour, time slipped through my fingers.`}</p>
    <p>{`Each day felt endless. Dragging. Like you couldn't find enough to do to fill such a long stretch of time.`}</p>
    <p>{`And then it's next week. 😳`}</p>
    <p>{`The year that felt like a drag and ended in the blink of an eye.`}</p>
    <p>{`Think of noteworthy events in your life since March. `}<em parentName="p">{`Your`}</em>{` life. Not politics, not news, not pandemics. What did `}<em parentName="p">{`you`}</em>{` do?`}</p>
    <p><video parentName="p" {...{
        "style": {
          "margin": "auto auto",
          "display": "block",
          "maxWidth": "80%"
        },
        "autoPlay": true,
        "loop": true,
        "muted": true,
        "playsInline": true,
        "loading": "lazy"
      }}>{`
            `}<source parentName="video" {...{
          "src": "https://media1.giphy.com/media/neJJVczTGFEha/giphy-loop.mp4?cid=7cf28b0fwdxqr7uh7v9f2x3kmt8tcpm6y75rlgri9v0du7g1&rid=giphy-loop.mp4&ct=g",
          "type": "video/mp4"
        }}></source>{`
        `}</video></p>
    <h2 {...{
      "id": "what-did-swiz-do"
    }}>{`What did Swiz do`}</h2>
    <p>{`I wish I could share a `}<a parentName="p" {...{
        "href": "https://swizec.com/blog/how-my-bank-account-went-from-dollar909-to-dollar50000-in-2019"
      }}>{`heroic story like last year`}</a>{`. A story of bucking trends, beating odds, winning life.`}</p>
    <p>{`Instead it's a story of grey. Habits, systems, brick stacking. Smol success.`}</p>
    <p>{`A story of days that felt meh. Without a goal, little direction, hanging on by a thread. Habits kept me going.`}</p>
    <h3 {...{
      "id": "new-habits"
    }}>{`New habits`}</h3>
    <p>{`I started a plague diary. Every morning I write 3 pages by hand. Clear the cobwebs. Write what comes to mind.`}</p>
    <blockquote {...{
      "className": "twitter-tweet",
      "data-dnt": "true"
    }}><p parentName="blockquote" {...{
        "lang": "en",
        "dir": "ltr"
      }}>{`On the first day of wfh, I started The Plague Diary — a daily handwritten journaling habit. On day 179, I start the 3rd notebook. We’re in it for the long haul friends `}<a parentName="p" {...{
          "href": "https://t.co/PYBy94LSjH"
        }}>{`pic.twitter.com/PYBy94LSjH`}</a></p>{`— Swizec Teller published ServerlessHandbook.dev (@Swizec) `}<a parentName="blockquote" {...{
        "href": "https://twitter.com/Swizec/status/1304792843223851009"
      }}>{`September 12, 2020`}</a></blockquote>
    <p>{`It's been wonderful. Better than the `}<a parentName="p" {...{
        "href": "https://750words.com"
      }}>{`750words.com`}</a>{` digital version.`}</p>
    <p>{`Writing by hand feels nice. Slow. Gets you off the computer. 😌`}</p>
    <p>{`And I've been getting up early!`}</p>
    <p>{`The guy who wrote `}<a parentName="p" {...{
        "href": "https://swizec.com/blog/why-programmers-work-at-night-2"
      }}>{`Why Programmers Work at Night`}</a>{` now gets up at 6am. Sometimes earlier.`}</p>
    <p>{`It's better that way. Lets you think your own thoughts before your brain is full of other people's crap.`}</p>
    <p>{`As long as you avoid the internet. I'm working on that part 😅`}</p>
    <h3 {...{
      "id": "trends-that-continued"
    }}>{`Trends that continued`}</h3>
    <p>{`2020 was the year of keeping on.`}</p>
    <p>{`Worked on my business in the mornings before the day job. That flow worked wonders.`}</p>
    <p>{`Translated to `}<a parentName="p" {...{
        "href": "https://wip.co/@swizec/year-in-review-2020"
      }}>{`1319 dones`}</a>{`, `}<a parentName="p" {...{
        "href": "https://swizec.com/blog"
      }}>{`94 new posts on swizec.com`}</a>{`, a few emails just for the newsletter. Not sure how many videos I uploaded to YouTube.`}</p>
    <p>{`But 234 video lessons on Vimeo 🤘 for folks who buy a course. The embedded player looks nicer.`}</p>
    <p>{`694 users of my new course platform. Coming back and logging in, not just buy and forget ❤️`}</p>
    <p><figure parentName="p" {...{
        "className": "gatsby-resp-image-figure",
        "style": {
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
    `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "890px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/c2501216ee0af46e0ff48ae528294e43/1166c/Login-activity-on-course-platform1e791c.jpg",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "36.32286995515695%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'145\\'%20viewBox=\\'0%200%20400%20145\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M21%2038l1%2015-3-1c-3%200-3%200-3%205v6h22v-3c-1-3%200-3%203-3h3V24H21v14m30%202v17h2c3%200%203%200%203-5l1-4v10h-6c-5%200-6%200-6%202%200%203%202%204%205%202h2c0%202%204%201%204-1l1-2v2c0%202%200%202%208%202h8V33l3%201c3%200%203%200%203-5v-5H51v16m35-10c0%205%200%205-3%205h-3v28h3l2-2c0-2%200-2%201%200s4%203%204%201h1c2%202%205%201%205-1%200-3%200-3-6-3h-6l1-4v-3l1%203c0%202%201%203%203%203s2%200%202-6%200-6%203-6l2-2c0-3-4-3-4%200-1%201-1%201-1-1s0-2%2011-2h6v-8c0-8%200-8-3-8-2%200-2%200-2%203l-1%203v-3c0-3%200-3-2-3-3%200-3%200-3%206l1%205h-4c-3%200-3%200-3-3%200-4%201-5%201-1%200%202%200%203%202%203%203%200%203-4%200-4v-1l2-2c0-3%200-3-5-3h-5v6m29-1c0%205%200%205%203%205%202%200%202%200%202-3%200-2%200-3%202-2%202%200%202%200%201%201-3%200-2%204%201%204l4%201h-4c-3%200-5%204-1%204l1%201-1%201c-2-1-2%200-2%208v9h-5c-6%200-6%200-6%202%200%203%201%203%204%202h1c0%202%205%201%205-1l1-2v2c0%203%205%203%205%200l-1-3v-1h4c2%200%202%200%202-6%200-5%200-6%202-6l2%201-1%201c-1%200-2%201-2%205%200%205%200%205%202%205h3V24h-2c-3%200-3%200-3%2010v10l-1-10V24h-5c-4%200-5%200-5%202h-1l-2-2c-3%200-3%200-3%205m23%2011l1%2017h4l5%201h-5c-4%200-5%200-4%202v2l11%201c10-1%2011-1%2011-3s0-2-2-2h-2l2-1c3-1%203-22%200-22l-2-1h9V24h-10v9l-1%206c0-4%200-4-4-4l-3-1h7V24h-17v16m35-10c1%205%201%205-2%205s-3%200-3%203c0%202%200%202%203%202%202%200%203%200%203%202s-2%203-2%201l-2-2c-4%200-3%204%201%204l4%201h-7v6c0%205%200%205%203%205%202%200%203%200%202%203v3h8c8-1%208-1%209-3%200-2%200-2-3-2h-4l4-1c3%200%203%200%203-3v-4l1%201c0%202%203%201%204-1v-9c0-5%200-6-2-6l-2%202%202%202%201%201-1%201c-2-1-2%200-2%201l-1%202V24h-17v6m30-2c-1%206-1%206%206%206%205%200%205%200%203%201-4%200-4%200-4%203v3l-1-3c0-2%200-3-2-3-4%200-4%2015%200%2016%202%201%203%200%203-3-1-2-1-3%206-3l6%201h-3c-3%200-3%200-3%203s0%203-3%203-3%200-3%203c0%202%200%202%203%202s3%200%203%203%200%203%205%203h6V50c0-14%200-15-3-15-2%200-2%201-2%205l-1%204v-1c0-1-1-2-3-2l-3-1h3c3%200%203%200%203-3-1-3%200-3%203-3%204%200%204-3%201-5l-1-1%202-1h1c2%203%206%202%206-1%200-1-1-2-6-2s-5%200-5%203l-1%204v-4c0-3%200-3-3-3-2%200-2%200-2%203%201%203%200%203-2%202l-1-1c3%200%203-4%200-4-2%200-2%201-2%203l-1%203-1-3c1-3%201-3-1-3s-3%201-3%204m35-2l2%202%201%201h-5c-4%200-4%200-4%203%200%202%200%202%206%202h6v4l-1%203-1-3c0-2%200-3-2-3s-3%203%200%205c1%201%201%201-1%201s-2-1-2-3c0-3%200-3-3-3h-2v11c0%2011%200%2011%202%2011%202-1%202-1%202-3%200-3%200-3%204-3%203%200%204%201%204%203s0%203%202%203%202%200%202-4c0-7%201-4%201%203%200%206%201%207%203%207s2%200%202-16V31l1%201%202%202c2%200%203%200%203-5%200-4-1-5-3-5-1%200-2%201-2%203l-1%204v-4c0-4-5-5-5%200l-1%203v-3c0-2-1-3-2-3-2%200-2%201-2%204l-1%201c-1%201-1%200-1-2s0-3-2-3l-2%202m29%207v9l-3-1c-3-1-3-1-3%202%200%202%200%203%202%203v1c-1%200-2%203-2%208%200%208%200%208%202%208%203%200%203%200%203-6l-1-5h-2c0-1%201-2%202-1%201%200%202-3%200-5v-1c2%200%202%201%202%206s0%206%202%206%202-1%202-5l4-1h4v6c0%205%200%206%202%206s2%200%202-3c-1-3%200-3%203-3h3V24h-2l-3%201h-1l-8-1h-8v9m35-3c0%205%200%205-3%205s-3%200-3%206v5h3l3-1v13h-6c-5%200-5%200-5%202l1%202h5c3%200%204-1%204-2%201-1%201-1%201%201s1%202%208%202h8V35h-2l-3%201h-1c0-3-4-1-4%202l-1%203v-3c0-4%200-5%208-4%203%200%203%200%203-3%200-2%200-2%203-2%202%200%203-1%203-3s0-2-9-2h-8v6l-1-3c0-2%200-3-2-3s-2%201-2%206m35-3c0%202%200%203-6%202h-6v28h3c2%200%202%200%202-6v-6h4l3%201-3%201-3-1v5l1%206c1%201%200%201-2%201-5%200-7%204-2%204l2-1v-2l1%202c0%202%203%203%205%201h1l2%201c2%200%203-3%202-5%200-2%200-2%203-2%202%200%203%200%203-2s0-2-3-2c-3%201-3%201-3-3%200-3%200-4%202-4v1c-2%202-1%205%202%205%202%200%203-4%200-4l1-1h7V24h-6c-5%200-5%200-5%203v3l-1-3c0-2%200-3-2-3s-2%201-2%203M97%20113c-1%203%200%205%203%206l2%201-3%201h-2c1%203%206%202%207-1l1-1%203%201%202%202h1v-9c0-1-2%200-3%202l-3%203-1-3c-1-3-6-4-7-2\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/c2501216ee0af46e0ff48ae528294e43/ca0a1/Login-activity-on-course-platform1e791c.webp 223w", "/static/c2501216ee0af46e0ff48ae528294e43/75680/Login-activity-on-course-platform1e791c.webp 445w", "/static/c2501216ee0af46e0ff48ae528294e43/8d1ba/Login-activity-on-course-platform1e791c.webp 890w", "/static/c2501216ee0af46e0ff48ae528294e43/3838e/Login-activity-on-course-platform1e791c.webp 1335w", "/static/c2501216ee0af46e0ff48ae528294e43/e11e5/Login-activity-on-course-platform1e791c.webp 1780w", "/static/c2501216ee0af46e0ff48ae528294e43/110ea/Login-activity-on-course-platform1e791c.webp 1831w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/c2501216ee0af46e0ff48ae528294e43/853b2/Login-activity-on-course-platform1e791c.jpg 223w", "/static/c2501216ee0af46e0ff48ae528294e43/0a4fe/Login-activity-on-course-platform1e791c.jpg 445w", "/static/c2501216ee0af46e0ff48ae528294e43/7f80b/Login-activity-on-course-platform1e791c.jpg 890w", "/static/c2501216ee0af46e0ff48ae528294e43/dc6ba/Login-activity-on-course-platform1e791c.jpg 1335w", "/static/c2501216ee0af46e0ff48ae528294e43/2d2e5/Login-activity-on-course-platform1e791c.jpg 1780w", "/static/c2501216ee0af46e0ff48ae528294e43/1166c/Login-activity-on-course-platform1e791c.jpg 1831w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/jpeg"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/c2501216ee0af46e0ff48ae528294e43/7f80b/Login-activity-on-course-platform1e791c.jpg",
                "alt": "Login activity on course platform",
                "title": "Login activity on course platform",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
          "className": "gatsby-resp-image-figcaption"
        }}>{`Login activity on course platform`}</figcaption>{`
  `}</figure></p>
    <p>{`And it looks like folks continue to enjoy my emails. Engagement fell because I didn't write in December, but looking good.`}</p>
    <p><figure parentName="p" {...{
        "className": "gatsby-resp-image-figure",
        "style": {
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
    `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "890px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/89b170caf9eec71dc5219186b4998cb1/0d9ab/ConvertKit-engagement-metricsicbjaj.jpg",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "47.98206278026906%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'192\\'%20viewBox=\\'0%200%20400%20192\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M388%2026l-1%2015-2%201%201%201c2-1%202%205%202%2044a1080%201080%200%20001-15%201851%201851%200%2000-1-46m-93%2060c-61%2029-63%2030-102%2031-36%201-96%201-111-1a1078%201078%200%2001-33-4c39%207%2079%209%20141%207%2039-1%2046-3%2083-21a1646%201646%200%200122-12\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/89b170caf9eec71dc5219186b4998cb1/ca0a1/ConvertKit-engagement-metricsicbjaj.webp 223w", "/static/89b170caf9eec71dc5219186b4998cb1/75680/ConvertKit-engagement-metricsicbjaj.webp 445w", "/static/89b170caf9eec71dc5219186b4998cb1/8d1ba/ConvertKit-engagement-metricsicbjaj.webp 890w", "/static/89b170caf9eec71dc5219186b4998cb1/3838e/ConvertKit-engagement-metricsicbjaj.webp 1335w", "/static/89b170caf9eec71dc5219186b4998cb1/e11e5/ConvertKit-engagement-metricsicbjaj.webp 1780w", "/static/89b170caf9eec71dc5219186b4998cb1/d8529/ConvertKit-engagement-metricsicbjaj.webp 2388w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/89b170caf9eec71dc5219186b4998cb1/853b2/ConvertKit-engagement-metricsicbjaj.jpg 223w", "/static/89b170caf9eec71dc5219186b4998cb1/0a4fe/ConvertKit-engagement-metricsicbjaj.jpg 445w", "/static/89b170caf9eec71dc5219186b4998cb1/7f80b/ConvertKit-engagement-metricsicbjaj.jpg 890w", "/static/89b170caf9eec71dc5219186b4998cb1/dc6ba/ConvertKit-engagement-metricsicbjaj.jpg 1335w", "/static/89b170caf9eec71dc5219186b4998cb1/2d2e5/ConvertKit-engagement-metricsicbjaj.jpg 1780w", "/static/89b170caf9eec71dc5219186b4998cb1/0d9ab/ConvertKit-engagement-metricsicbjaj.jpg 2388w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/jpeg"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/89b170caf9eec71dc5219186b4998cb1/7f80b/ConvertKit-engagement-metricsicbjaj.jpg",
                "alt": "ConvertKit engagement metrics",
                "title": "ConvertKit engagement metrics",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
          "className": "gatsby-resp-image-figcaption"
        }}>{`ConvertKit engagement metrics`}</figcaption>{`
  `}</figure></p>
    <h3 {...{
      "id": ""
    }}>{`\\`}{`$`}{`\\`}{`$`}{`\\`}{`$`}</h3>
    <blockquote {...{
      "className": "twitter-tweet",
      "data-dnt": "true"
    }}><p parentName="blockquote" {...{
        "lang": "en",
        "dir": "ltr"
      }}>{`I've always been fascinated by your transparency about your financial progress over the years - what have you learned, financial growth, good/bad decisions, how you are spending money/savings accounts. For me personally, It has been enormously motivating and has helped me a lot!`}</p>{`— Zan Keglic (@ZanKeglic) `}<a parentName="blockquote" {...{
        "href": "https://twitter.com/ZanKeglic/status/1344418996989399041"
      }}>{`December 30, 2020`}</a></blockquote>
    <p><a parentName="p" {...{
        "href": "https://swizec.com/blog/how-my-bank-account-went-from-dollar909-to-dollar50000-in-2019#profit-first-or-how-i-actually-saved-50k-and-paid-off-debt"
      }}>{`Following the Profit First method`}</a>{` has done wonders. The year felt stable with little stress.`}</p>
    <p>{`It helps that `}<a parentName="p" {...{
        "href": "https://swizec.com/blog/how-to-grow-as-a-senior-engineer-or-why-i-got-a-new-job"
      }}>{`in June I changed jobs`}</a>{`. Now there's exciting new challenges and way more salary.`}</p>
    <p>{`Was going to make a product around job searching and interviewing, but the process took a week. There was nothing to say.`}</p>
    <p>{`It surprised me how easy the path to ridiculous money is in San Francisco. As long as you're okay working for someone else. 2 days of effort turned into a $40k raise 😅`}</p>
    <p>{`That shook me. Rocked my worldview.`}</p>
    <blockquote {...{
      "className": "twitter-tweet",
      "data-dnt": "true"
    }}><p parentName="blockquote" {...{
        "lang": "en",
        "dir": "ltr"
      }}>{`$59k in product sales 👉 hard work and hustle`}<br parentName="p"></br>{`$159k in salary 👉 lots of time but super chill`}<br parentName="p"></br>{`$43k in stock returns 👉 hard on the nerves, no work`}<br parentName="p"></br><br parentName="p"></br>{`capitalism is weird`}</p>{`— Swizec Teller published ServerlessHandbook.dev (@Swizec) `}<a parentName="blockquote" {...{
        "href": "https://twitter.com/Swizec/status/1339734033081671683"
      }}>{`December 18, 2020`}</a></blockquote>
    <p>{`Yes those are my numbers.`}</p>
    <p>{`Going into 2021, the LLC has a 6 month runway for my salary (dayjob pays through LLC for reasons), prepaid all taxes, got 100k in my index funds, and 50k in the retirement fund.`}</p>
    <blockquote {...{
      "className": "twitter-tweet",
      "data-dnt": "true"
    }}><p parentName="blockquote" {...{
        "lang": "en",
        "dir": "ltr"
      }}>{`Achievement unlocked: Zero to 6-figure savings in 4 years 🤘 🎉 `}<br parentName="p"></br><br parentName="p"></br>{`Yes I know this is in bad taste but fuck it I get to celebrate my life achievements even in 2020 `}<a parentName="p" {...{
          "href": "https://t.co/PiHNt8gGyt"
        }}>{`pic.twitter.com/PiHNt8gGyt`}</a></p>{`— Swizec Teller published ServerlessHandbook.dev (@Swizec) `}<a parentName="blockquote" {...{
        "href": "https://twitter.com/Swizec/status/1331284284154335232"
      }}>{`November 24, 2020`}</a></blockquote>
    <p>{`The pressure is off and that's weird.`}</p>
    <p>{`For the last 32 years of my life, money has been `}<em parentName="p">{`the`}</em>{` source of stress, worry, concern, and drive. Now I'm fast approaching the `}<em parentName="p">{`"Eh it's just money"`}</em>{` mentality.`}</p>
    <p>{`And I look at my bank account every day. `}<em parentName="p">{`"Is it still there? Was I dreaming? Am I safe? What did I forget to pay, this can't be real"`}</em></p>
    <p>{`People who experienced broke-ness get it.`}</p>
    <h3 {...{
      "id": "bricks-that-got-stacked"
    }}>{`Bricks that got stacked`}</h3>
    <p>{`2020 saw a lot of brick stacking. Work that takes time and effort today and brings results tomorrow.`}</p>
    <p>{`Or next year 🤞`}</p>
    <p>{`A big one was `}<a parentName="p" {...{
        "href": "https://swizec.com/blog/lessons-from-migrating-a-14-year-old-blog-with-1500-posts-to-gatsby"
      }}>{`migrating swizec.com from Wordpress to Gatsby`}</a>{`. Huge improvement in readability, authoring, and reader experience.`}</p>
    <p>{`Needs more but it's a great start.`}</p>
    <p>{`And there's a course platform now! `}<a parentName="p" {...{
        "href": "https://reactfordataviz.com"
      }}>{`ReactForDataviz.com`}</a>{`, `}<a parentName="p" {...{
        "href": "https://serverlessreact.dev"
      }}>{`ServerlessReact.dev`}</a>{`, and `}<a parentName="p" {...{
        "href": "https://serverlesshandbook.dev"
      }}>{`ServerlessHandbook.dev`}</a>{` run off the same Gatsby codebase packaged as an NPM install. 🤘`}</p>
    <p>{`Super exciting. I think there's big potential here.`}</p>
    <p>{`Best part is that I can create different newsletter signup flows for different topics. That's going to be a fun playground in 2021.`}</p>
    <p>{`Another great bit of brick stacking were the workshops and research I did in Q4 – September to December. Building a huge revamp of ServerlessReact to launch soon.`}</p>
    <p>{`And we can't forget `}<a parentName="p" {...{
        "href": "https://useauth.dev"
      }}>{`useAuth.dev`}</a>{`. Not sure yet if that's a brick or a distraction, but it's helping people with an annoying task.`}</p>
    <p>{`Fingers crossed the hard work improves this graph.`}</p>
    <p><figure parentName="p" {...{
        "className": "gatsby-resp-image-figure",
        "style": {
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
    `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "890px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/abb89c0ac6cf01bfeacdd739902d4467/83c60/Gumroad-sales-graph-for-20200347f6.jpg",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "50.224215246636774%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'201\\'%20viewBox=\\'0%200%20400%20201\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M41%2015c-2%202-2%209%200%2011%203%203%208%200%208-6%200-5-5-8-8-5m6%2072a2203%202203%200%20011%2065c1%2021%201%2026%203%2028l2%201c0-2%202-1%202%201%201%201%202%202%205%201h3c0%201%204%201%205-1h2c1%202%209%202%2010%200h-1c-1%201-7-1-7-3%200-1-2-1-4%201-2%201-7%201-9-1h-4c-1-2-1-2-2-1-2%204-3-4-4-57-1-54-2-72-2-34m238%2086c0%206-2%209-5%209l-3-2c0-3-1-3-2-1-1%204-3%204-3%201l-1-2v2c-1%202-2%202-6%202l-5-1h-3c-3%201-3%201-3-1h-1c-2%202-3%202-3%201l-1-2-1%202a110%20110%200%2001-37%200c-1%202-3%200-3-2l-1-2-1%203-2%202-2-1c0-2-4-3-4-1h-1c0-2-2-1-2%201%200%201-2%202-2%200h-3c-3%202-3%204%200%202h9l42%201c44-1%2043%200%2045-5%201-1%201-1%201%201l1%202h1c0%202%208%203%2010%201h1l8%201%207-1h2c3%201%202%201%204-3%201-4%201-4%201-1%200%204%201%204%205%205%204%200%207-1%207-3%200-3-2-3-3-1%200%203%200%203-3%202l-3-1-1-2c-2-7-5-7-5%201%200%202-2%203-3%200l-2%201c-1%201-1%201-2-1l-1-2-1%202c0%202-6%203-6%201h-4l-1-2-1%202-3%201-3-1-2-2c-2%200-3-3-3-8%200-6-1-5-2%202m-154-1l-1%201-1%204c0%204-1%205-3%205-3%200-3%200-3-2l-1-3-1%203c0%202%200%202-5%202-4%200-5%200-5-2l-1-2-1%202h-1c-1-1-5%202-5%203a147%20147%200%200027-1c1-3%203-4%203-1l1%203h11c8%200%2011-1%2012-2h1c1%202%204%202%206%201h3l14-1h6l-7-3c-1%201-1%200-1-2l-1-3c-1-1-1%200-1%203%200%204-2%206-3%204h-3c-1%202-1%202-4%200h-8c0-2-3-3-3-1h-1c-1-2-1-2-2%200%200%202-3%203-5%201h-13l-2-6c0-4-2-7-2-3\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/abb89c0ac6cf01bfeacdd739902d4467/ca0a1/Gumroad-sales-graph-for-20200347f6.webp 223w", "/static/abb89c0ac6cf01bfeacdd739902d4467/75680/Gumroad-sales-graph-for-20200347f6.webp 445w", "/static/abb89c0ac6cf01bfeacdd739902d4467/8d1ba/Gumroad-sales-graph-for-20200347f6.webp 890w", "/static/abb89c0ac6cf01bfeacdd739902d4467/3838e/Gumroad-sales-graph-for-20200347f6.webp 1335w", "/static/abb89c0ac6cf01bfeacdd739902d4467/e11e5/Gumroad-sales-graph-for-20200347f6.webp 1780w", "/static/abb89c0ac6cf01bfeacdd739902d4467/df82e/Gumroad-sales-graph-for-20200347f6.webp 2050w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/abb89c0ac6cf01bfeacdd739902d4467/853b2/Gumroad-sales-graph-for-20200347f6.jpg 223w", "/static/abb89c0ac6cf01bfeacdd739902d4467/0a4fe/Gumroad-sales-graph-for-20200347f6.jpg 445w", "/static/abb89c0ac6cf01bfeacdd739902d4467/7f80b/Gumroad-sales-graph-for-20200347f6.jpg 890w", "/static/abb89c0ac6cf01bfeacdd739902d4467/dc6ba/Gumroad-sales-graph-for-20200347f6.jpg 1335w", "/static/abb89c0ac6cf01bfeacdd739902d4467/2d2e5/Gumroad-sales-graph-for-20200347f6.jpg 1780w", "/static/abb89c0ac6cf01bfeacdd739902d4467/83c60/Gumroad-sales-graph-for-20200347f6.jpg 2050w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/jpeg"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/abb89c0ac6cf01bfeacdd739902d4467/7f80b/Gumroad-sales-graph-for-20200347f6.jpg",
                "alt": "Gumroad sales graph for 2020",
                "title": "Gumroad sales graph for 2020",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
          "className": "gatsby-resp-image-figcaption"
        }}>{`Gumroad sales graph for 2020`}</figcaption>{`
  `}</figure></p>
    <h3 {...{
      "id": "building-a-team"
    }}>{`Building a team`}</h3>
    <p>{`Oh, I've been building a team. Outsource aspects of business that others can do.`}</p>
    <blockquote {...{
      "className": "twitter-tweet",
      "data-dnt": "true"
    }}><p parentName="blockquote" {...{
        "lang": "en",
        "dir": "ltr"
      }}>{`3 interviews tomorrow`}<br parentName="p"></br>{`3 on sunday`}<br parentName="p"></br>{`2 monday morning`}<br parentName="p"></br><br parentName="p"></br>{`So many people wanna help with my sidehustle stuff 😍 `}<a parentName="p" {...{
          "href": "https://t.co/LcM3qxE36x"
        }}>{`pic.twitter.com/LcM3qxE36x`}</a></p>{`— Swizec Teller published ServerlessHandbook.dev (@Swizec) `}<a parentName="blockquote" {...{
        "href": "https://twitter.com/Swizec/status/1253796006698737664"
      }}>{`April 24, 2020`}</a></blockquote>
    <p>{`Harder than I thought. Mad respect to everyone who gets it right fast.`}</p>
    <p>{`We're making good progress. Coming together, building systems, figuring out how to do it right. I fear I jumped too early and there isn't enough demand and revenue.`}</p>
    <p>{`But without this I'll die. Can't do everything yourself. Such is the bootstrapping paradox.`}</p>
    <p>{`There's entire blogs I could write about this. Lemme know if you're interested.`}</p>
    <h2 {...{
      "id": "what-swiz-failed-to-do"
    }}>{`What Swiz failed to do`}</h2>
    <p>{`Highlights are nothing without the lowlights.`}</p>
    <p>{`Here's everything that failed:`}</p>
    <ul>
      <li parentName="ul">{`did not make $130k in product sales (the main goal)`}</li>
      <li parentName="ul">{`didn't finish `}<a parentName="li" {...{
          "href": "https://serverlesshandbook.dev"
        }}>{`ServerlessHandbook.dev`}</a>{` (1.5 chapters left)`}</li>
      <li parentName="ul">{`disappointed folks with editing delays on ServerlessReact.dev`}</li>
      <li parentName="ul">{`failed to make SRD as good as I wanted (fixing)`}</li>
      <li parentName="ul">{`didn't start a daily short video thing`}</li>
      <li parentName="ul">{`couldn't grow sales for RDV (still at $1k/month average)`}</li>
      <li parentName="ul">{`didn't crack newsletter growth (churn and growth are balanced)`}</li>
      <li parentName="ul">{`didn't build markdownemail.com`}</li>
      <li parentName="ul">{`failed to fix UX of SparkJoy widgets at bottom of emails`}</li>
      <li parentName="ul">{`didn't build a SaaS`}</li>
      <li parentName="ul">{`failed to build a marketing flywheel`}</li>
      <li parentName="ul">{`failed to outsource parts of creation process`}</li>
      <li parentName="ul">{`did not take a break after every quarter`}</li>
      <li parentName="ul">{`haven't productized the course platform`}</li>
      <li parentName="ul">{`can't run 26km under 2 hours`}</li>
    </ul>
    <p>{`😅`}</p>
    <h2 {...{
      "id": "a-year-of-lasts"
    }}>{`A year of lasts`}</h2>
    <p>{`Towards December 2020 a thing became clear: I need to kill my darlings.`}</p>
    <p>{`Too many projects that are in progress. Too many good habits. Too much everything.`}</p>
    <blockquote {...{
      "className": "twitter-tweet",
      "data-dnt": "true"
    }}><p parentName="blockquote" {...{
        "lang": "en",
        "dir": "ltr"
      }}>{`Friends, ever feel like you're working working working and nothing's happening? Me too. `}<br parentName="p"></br><br parentName="p"></br>{`I think there's 3 reasons:`}<br parentName="p"></br><br parentName="p"></br>{`1. You're burning out`}<br parentName="p"></br>{`2. You're working on the wrong things`}<br parentName="p"></br>{`3. You're a lion chasing mice`}<a parentName="p" {...{
          "href": "https://twitter.com/hashtag/DeepWorkDecember?src=hash&ref_src=twsrc%5Etfw"
        }}>{`#DeepWorkDecember`}</a><br parentName="p"></br><br parentName="p"></br>{`📹 `}<a parentName="p" {...{
          "href": "https://t.co/QKJIqgFUY2"
        }}>{`https://t.co/QKJIqgFUY2`}</a>{` `}<a parentName="p" {...{
          "href": "https://t.co/s8d19nahqF"
        }}>{`pic.twitter.com/s8d19nahqF`}</a></p>{`— Swizec Teller published ServerlessHandbook.dev (@Swizec) `}<a parentName="blockquote" {...{
        "href": "https://twitter.com/Swizec/status/1334201415078612993"
      }}>{`December 2, 2020`}</a></blockquote>
    <p>{`This year I want to go deep. Fewer projects. More shipping, more value, bigger. Focus on long-term games and building assets.`}</p>
    <p>{`Don't know what's getting killed yet. I love my darlings. ❤️`}</p>
    <p>{`What's your plan for 2021? How can I help?`}</p>
    <p>{`Happy new year,`}<br />{`
~Swizec`}</p>
    <p>{`PS: can you answer `}<a parentName="p" {...{
        "href": "https://swizecteller.typeform.com/to/Sko9g6tM"
      }}>{`a couple questions about these emails`}</a>{` to help me improve?`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      